"use client";

import { useState } from "react";
import PhosphorIcon from "@/shared/components/common/PhosphorIcon";
import type { HotelDetailV2Model } from "../model/hotelDetailV2.model";
import { EmptyContent } from "./AboutSection";
import { SampleBadge } from "./ReviewsSection";

interface FaqSectionProps {
  hotel: HotelDetailV2Model;
}

export default function FaqSection({ hotel }: FaqSectionProps) {
  const [open, setOpen] = useState<number | null>(0);
  const hasSample = hotel.faqs.some((item) => item.isSample);

  return (
    <section
      id="faq"
      className="scroll-mt-28 rounded-2xl border border-[rgb(229,231,235)] bg-white p-5"
    >
      <div className="mb-4 flex items-center justify-between gap-3">
        <h2 className="text-base font-bold text-[#1a1a2e]">سوالات متداول</h2>
        {hasSample ? <SampleBadge /> : null}
      </div>

      {hotel.faqs.length > 0 ? (
        <div className="space-y-2">
          {hotel.faqs.map((item, index) => (
            <div
              key={item.id}
              className="overflow-hidden rounded-xl border border-[rgb(229,231,235)]"
            >
              <button
                type="button"
                onClick={() => setOpen(open === index ? null : index)}
                className="flex w-full items-center justify-between gap-3 p-4 text-right transition-colors hover:bg-gray-50"
              >
                <span className="flex items-center gap-2.5">
                  <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full border border-[rgb(229,231,235)] text-xs text-[#6b7280]">
                    ?
                  </span>
                  <span className="text-sm font-semibold text-[#1a1a2e]">
                    {item.question}
                  </span>
                </span>
                <PhosphorIcon
                  name={open === index ? "CaretUp" : "CaretDown"}
                  size={16}
                  className="shrink-0 text-[#6b7280]"
                />
              </button>
              {open === index ? (
                <div className="border-t border-[#f0f0f0] px-4 pb-4 pt-3 text-sm leading-6 text-[#6b7280]">
                  {item.answer}
                </div>
              ) : null}
            </div>
          ))}
        </div>
      ) : (
        <EmptyContent text="سوالی برای این هتل ثبت نشده است." />
      )}
    </section>
  );
}
